import PropTypes from 'prop-types'

import { FormRow, Label } from 'basic-components'
import { DataScienceEnums } from 'dashboard-services/api/dataScience'
import { CommonService } from 'dashboard-services/services'

import ValueTypeResolverBody from 'components/modules/DataScience/PipelineCreator/Options/ValueTypeResolver/Body'
import ValueTypeResolverHeader from 'components/modules/DataScience/PipelineCreator/Options/ValueTypeResolver/Header'

const { DATALAKE_FILE, TEXT_AREA, JSON: JSON_VALUE_TYPE, STRING } = DataScienceEnums.TASK_PARAM_VALUE_TYPE

const ParamValue = ({ getAllParams, menuPortalTarget, onChangeParamValue, paramDef, paramName, paramValue, taskName }) => (
  <FormRow className="data-lake__group-dialog__advanced__dynamic-validation__row data-lake__group-dialog__advanced__dynamic-validation__row--with-indent">
    <Label
        noError
        required={paramDef?.valueType === DATALAKE_FILE ? false : !paramDef?.optional}
    >
      {paramDef?.valueType === DATALAKE_FILE ? "" : paramDef?.readableName || paramDef?.name}
    </Label>
    {paramDef?.valueType !== TEXT_AREA && paramDef?.valueType !== JSON_VALUE_TYPE ? (
      <ValueTypeResolverBody
          className="data-lake__group-dialog__advanced__dynamic-validation__row__vtr"
          dependsOnParam={paramDef?.dependsOnParam}
          disabled={false}
          fileExtension={paramDef?.fileExtension}
          fileType={paramDef?.fileType}
          menuPortalTarget={menuPortalTarget}
          name={paramName}
          noError
          onChange={onChangeParamValue}
          optional={paramDef?.optional}
          options={paramDef?.options}
          readableName={paramDef?.readableName}
          referenceDependsOnParam={paramDef?.referenceDependsOnParam}
          taskName={taskName}
          value={paramValue || ""}
          valueType={paramDef?.valueType || STRING}
          withBoolean
          withProvider={paramDef?.withProvider}
      />
    ) : (
      <ValueTypeResolverHeader
          expression={paramDef?.expression}
          getAllParams={getAllParams}
          name={paramName}
          onChange={onChangeParamValue}
          optional
          readableName={paramDef?.readableName}
          taskName={taskName}
          value={paramDef?.valueType === TEXT_AREA ? paramValue?.toString() : (CommonService.isJson(paramValue) ? JSON.parse(paramValue) : paramValue)}
          valueType={paramDef?.valueType}
      />
    )}
  </FormRow>
)

ParamValue.propTypes = {
  getAllParams: PropTypes.func.isRequired,
  menuPortalTarget: PropTypes.object,
  onChangeParamValue: PropTypes.func.isRequired,
  paramDef: PropTypes.object,
  paramName: PropTypes.string.isRequired,
  paramValue: PropTypes.any,
  taskName: PropTypes.string
}

export default ParamValue
